import { Box } from "@mui/material";
import { RedirectsDisplay } from "../general";
import { Page } from "../../general";

const Redirects = () => {
    return (
        <Page label="Redirects">
            <Box sx={{
                display: 'flex', 
                flexDirection: 'column', 
                gap: { sm: 2 }}
            }>
                <RedirectsDisplay />
            </Box>
        </Page>
    );
};

export default Redirects;